export default function roomSettingEventListener(room) {
    return store => {
        room.addEventListeners({
            room_setting_change_cameraRole: data => {
                store.commit('roomSetting/CHANGE_CAMERA_ROLE', data.data['defaultRoleCamera'])
            },
            room_setting_change_micRole: data => {
                store.commit('roomSetting/CHANGE_MIC_ROLE', data.data['defaultRoleMic'])
            },
            room_setting_change_resetRole: data => {
                store.commit('roomSetting/CHANGE_RESET_ROLE', data.data['defaultRoleReset'])
            },
            room_setting_change_defaultRoleId: data => {
                store.commit('roomSetting/CHANGE_DEFAULT_ROLEID', data.data['defaultRoleId'])
            },
            room_setting_change_defaultDevice: data => {
                store.commit('roomSetting/CHANGE_DEFAULT_DEVICE', data.data['defaultDeviceType'])
            },
            room_setting_change_chatMode: data => {
                store.commit('roomSetting/CHANGE_CHAT_MODE', data.data['useChat'])
            },
            room_setting_change_waitingMode: data => {
                store.commit('roomSetting/CHANGE_WAITING_MODE', data.data['useWaitingMode'])
            },
            room_setting_change_deviceRequired: data => {
                store.commit('roomSetting/CHANGE_DEVICE_REQUIRED', data.data['isDeviceRequired'])
            },
            room_setting_change_translateMode: data => {
                store.commit('roomSetting/CHANGE_TRANSLATE_MODE', data.data['useTranslate'])
            },
            room_setting_change_stickerMode: data => {
                store.commit('roomSetting/CHANGE_STICKER_MODE', data.data['useSticker'])
            },
            room_setting_change_docMargin: data => {
                store.commit('roomSetting/CHANGE_DOC_MARGIN', data.data['useDocMargin'])
            },
            room_setting_change_useQnA: data => {
                store.commit('roomSetting/CHANGE_USE_QNA', data.data['useQnA'])
            },
            room_setting_change_useQnAShare: data => {
                store.commit('roomSetting/CHANGE_USE_QNA_SHARE', data.data['useQnAShare'])
            },
        })
    }
}